module.exports = __webpack_public_path__ + "img/about_num2.1109d07.png";